<template>
  <div class="clearfix">
    <a-upload
      :action="uploadImgUrl"
      :show-upload-list="false"
      :headers="headers"
      @change="handleChange"
    >
      <div class="video-main">
        <a-button :loading="loading"> <a-icon type="upload" /> {{ $t('上传视频') }} </a-button>
      </div>
    </a-upload>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'image'
    },
    count: {
      type: Number,
      default: 1
    }
  },
  components: {
  },
  data () {
    return {
      loading: false,
      open: false,
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/common/local/file/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
      }
    }
  },
  mounted () {
  },
  methods: {
    handleCancel () {
      this.previewVisible = false
    },
    async handleChange (info) {
      console.log('video-info', info)
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.code !== '20001') {
          this.$message.error('上传失败' + info.file.response.message)
          this.loading = false
          return
        }
        this.loading = false
        this.$emit('change', { url: info.file.response.data })
      }
    },
    beforeUpload (file) {
      // 文件类型(file.type)、大小限制(file.size)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小限制 2MB!')
      }
      return isLt2M
    }
  }
}
</script>
<style lang="less" scoped>
.video-main {
  display: flex;
  flex-direction: column;
}

</style>
